import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: row;

  .mdc-chip-set {
    flex-wrap: initial;
    padding: 4px 0;
  }
`;
